/**
 * Analytics Utility
 *
 * Lightweight analytics wrapper for tracking user events.
 * Can be integrated with PostHog, Mixpanel, Amplitude, or Google Analytics.
 *
 * For now, logs to console in development and can be extended for production.
 */

interface AnalyticsEvent {
  event: string;
  properties?: Record<string, unknown>;
  timestamp?: string;
}

class Analytics {
  private enabled: boolean;
  private debug: boolean;

  constructor() {
    this.enabled = true;
    // Debug mode: enable console logging (can be disabled with setEnabled)
    // In production, this would be integrated with actual analytics service
    this.debug = true;
  }

  /**
   * Track an event
   */
  track(event: string, properties?: Record<string, unknown>): void {
    if (!this.enabled) return;

    const analyticsEvent: AnalyticsEvent = {
      event,
      properties,
      timestamp: new Date().toISOString(),
    };

    if (this.debug) {
      console.log('[Analytics]', analyticsEvent);
    }

    // TODO: Integrate with analytics service (PostHog, Mixpanel, etc.)
    // Example:
    // if (typeof window !== 'undefined' && window.posthog) {
    //   window.posthog.capture(event, properties);
    // }
  }

  /**
   * Identify user
   */
  identify(userId: string, traits?: Record<string, unknown>): void {
    if (!this.enabled) return;

    if (this.debug) {
      console.log('[Analytics] Identify:', { userId, traits });
    }

    // TODO: Integrate with analytics service
  }

  /**
   * Enable/disable tracking
   */
  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }
}

// Singleton instance
export const analytics = new Analytics();

// Convenience export
export default analytics;
